import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../images/Gradient Logo.png';
import home from '../images/home.png'
import metrics from '../images/metrics.png'
import forecast from '../images/forecast.png'
import benchmarks from '../images/benchmark.png'
import will from '../images/Will Hurd.png'
import './Navbar.css';

function Navbar() {
  const navigate = useNavigate();
  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };
  return (
    <nav className="navbar">
    <Link to="/" className="navbar-logo">
      <img src={logo} alt="Logo" />
    </Link>
    <div className="navbar-icons">
    <Link to="/" className="nav-icon" onClick={() => handleNavigation('/')}>
          <img src={home} alt="Home" />
        <span>Home</span>
      </Link>
      <Link to="/political_bias" className="nav-icon" onClick={() => handleNavigation('/political_bias')}>
         <img src={metrics} alt="Political Bias" />
        <span>Political Bias</span>
      </Link>
      <Link to="/positivity_sentiment" className="nav-icon" onClick={() => handleNavigation('/positivity_sentiment')}>
          <img src={forecast} alt="Positivity Sentiment" />
        <span>Positivity Sentiment</span>
      </Link>
      <Link to="/media_mentions" className="nav-icon" onClick={() => handleNavigation('/media_mentions')}>
          <img src={benchmarks} alt="Benchmarks" />
        <span>Media Mentions</span>
      </Link>
    </div>
    <Link to="/" className="navbar-will-hurd" onClick={() => handleNavigation('/')}>
        <img src={will} alt="Will Hurd" />
    </Link>
  </nav>
  );
}

export default Navbar;
